<template>
  <div
    class="day"
    :class="[variant, {'disabled': disabled}]"
  >
    <div class="day-text">
      {{ dayText }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import * as z from 'zod';
import dayjs from 'dayjs';
import { getHebrewDayOfWeek } from '../../utils/date';

interface Props {
  date: Date,
  disabled: boolean,
}
const props = defineProps<Props>();
const VariantsEnum = z.enum(['currentDate', 'passedDate', 'futureDate']);

const dayText = computed(() => getHebrewDayOfWeek(props.date));
const variant = computed(() => {
  if (dayjs().isSame(dayjs(props.date), 'day')) {
    return VariantsEnum.Enum.currentDate;
  } if (dayjs(props.date).isAfter(dayjs(), 'day')) {
    return VariantsEnum.Enum.futureDate;
  }
  return VariantsEnum.Enum.passedDate;
});
</script>

<style lang="scss" scoped>
@import 'base-ui-vue3/src/scss/riseup-colors';

.day {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  height: 40px;
  width: 40px;
  .day-text {
    color: $riseup_blue;
    font-size: 18px;
    font-family: SimplerPro;
  }

  &.currentDate {
    border: 2px solid $riseup_blue;
    .day-text {
      font-weight: bold;
    }
  }
  &.futureDate {
    border: 2px solid $riseup_light_blue;
  }
  &.passedDate {
    background-color: $riseup_green;
    .day-text {
      color: $riseup_light_green;
    }
  }
  &.disabled {
    border: 2px solid $riseup_gray_0;
    .day-text {
      color: $riseup_gray_2;
    }

  }
}
</style>
